import React from 'react';

export const ADMIN_SEQUENCE_LIST_COLUMNS = [
  {
    accessorKey: 'seq_type',
    header: 'Sequence Type',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { seq_type } = original;

      return <span>{seq_type || '-'}</span>;
    },
  },
  {
    accessorKey: 'prefix',
    header: 'Prefix',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { prefix } = original;

      return <span>{prefix || '-'}</span>;
    },
  },
  {
    accessorKey: 'last_value',
    header: 'Last Value',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { last_value } = original;

      return <span>{last_value || '-'}</span>;
    },
  },
];
